module.exports = __webpack_public_path__ + "static/img/cont65 (1).3f0705a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont65 (1).jpg
// module id = mfck
// module chunks = 0